import React from 'react';
import { Field, ErrorMessage } from 'formik';
import * as yup from 'yup';

const CurrencyField = ({ form, field, label_text, helper_text, isDisabled,Icon, isRequired }) => {
    const formatCurrency = (value) => {
        if (!value) return '';
        const formattedValue = value.toLocaleString("de-DE", {
            style: "currency",
            currency: "EUR",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        });
        return formattedValue.replace(/[^\d.,]/g, '').trim();
    };

    const handleChange = (e) => {
        const rawValue = e.target.value.replace(/[^0-9]/g, '');
        const numericValue = parseFloat(rawValue); 
        form.setFieldValue(field, numericValue);
    };

    const handleBlur = (e) => {
        const rawValue = e.target.value.replace(/[^0-9]/g, '');
        const numericValue = parseFloat(rawValue); 
        form.setFieldValue(field, numericValue, true);
    };

    return (
        <div>
            {label_text && (
                <label htmlFor={field} className={"text-xs font-medium inline-block"}>
                    {label_text}
                    {isRequired && <span className=''>*</span>}
                </label>
            )}
            <div className='relative flex items-center'>
            {
                        Icon &&
                        <Icon className="text-xl absolute left-2 text-black" />
                    }
                <Field
                    as={"input"}
                    type="text"
                    name={field}
                    id={field}
                    disabled={isDisabled}
                    placeholder={helper_text ? helper_text : ""}
                    value={formatCurrency(form.values[field])}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={`resize-none h-[45px] disabled:bg-gray-100 disabled:cursor-not-allowed input-text ${
                        form.touched[field] && form.errors[field] ? "input-text-error" : ""
                    }
                    ${Icon ? "!pl-7" : ""} ${
                        form.values[field] && form.values[field].toString().length > 0 && "input-text-active"
                    }`}
                />
            </div>
            <p className="text-xs text-red-500">
                <ErrorMessage name={field} />
            </p>
        </div>
    );
};

export default CurrencyField;
